import {UrlObject} from 'url'

import Link from 'next/link'
import {memo, ReactNode} from 'react'

import {IcTxtArrowSmallBold} from '@defign/ui'
import {Action, AUParam, sendAULog} from '@financial/common-logs'
import classNames from 'classnames/bind'

import IconNone from '$assets/IconSvgs/insurance/IconNone'
import SummaryText from '$components/insurance/my/home/diagnosis/SummaryText'
import {sendClickNlog} from '$utils/nlog'

import styles from './InsuranceComparison.module.scss'

const cx = classNames.bind(styles)

interface InsuranceComparisonProps {
    title: string
    list: {
        name: string
        href: string | UrlObject
        color: 'red' | 'yellow' | 'blue'
        amount: string
        nlog: string
        aulog: AUParam
        badge?: string
        rate?: string
        peer?: string
        way?: string
    }[]
    description?: ReactNode
    typeSingle?: boolean
}
function InsuranceComparison({title, list, description, typeSingle = false}: InsuranceComparisonProps) {
    return (
        <div className={cx('article')}>
            <h5 className={cx('title')}>{title}</h5>
            <ul className={cx('list', {'type-single': typeSingle})}>
                {list.map((item, index) => (
                    <li key={index} className={cx('item')}>
                        <strong>
                            <Link
                                href={item.href}
                                className={cx('link', `type-${item.color}`)}
                                onClick={(e) => {
                                    if (item.href === '') {
                                        e.preventDefault()
                                    }
                                    sendClickNlog(item.nlog)
                                    sendAULog(item.aulog, Action.Click)
                                }}
                            >
                                {typeSingle ? (
                                    <>
                                        {item.name}
                                        <span className={cx('way')}>
                                            {item.way}
                                            <span className={cx('icon')}>
                                                <IcTxtArrowSmallBold
                                                    width={6}
                                                    height={10}
                                                    fill={item.color === 'blue' ? '#007eff' : '#f73631'}
                                                />
                                            </span>
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        {item.name}
                                        <span className={cx('icon')}>
                                            <IcTxtArrowSmallBold width={6} height={10} fill="#404048" />
                                        </span>
                                        <span className={cx('rate')}>
                                            <span className={cx('badge')}>{item.badge}</span>
                                            {item.rate}
                                        </span>
                                    </>
                                )}
                            </Link>
                        </strong>
                        {typeSingle ? (
                            <div className={cx('area-amount')}>
                                {item.amount === '없음' ? (
                                    <>
                                        <IconNone width={22} height={21} />
                                        <span className="blind">없음</span>
                                    </>
                                ) : (
                                    <>{item.amount}</>
                                )}
                            </div>
                        ) : (
                            <>
                                <div className={cx('area-amount')}>
                                    {index === 0 ? (
                                        <span className={cx('badge')}>또래</span>
                                    ) : (
                                        <span className="blind">또래</span>
                                    )}
                                    <span className={cx('amount')}>{item.peer}</span>
                                </div>
                                <div className={cx('area-amount')}>
                                    {index === 0 ? (
                                        <span className={cx('badge')}>나</span>
                                    ) : (
                                        <span className="blind">나</span>
                                    )}
                                    <span className={cx('amount')}>{item.amount}</span>
                                </div>
                            </>
                        )}
                    </li>
                ))}
            </ul>
            {description && <SummaryText text={description} />}
        </div>
    )
}

export default memo(InsuranceComparison)
